import $ from 'jquery';

function accordion() {
	document.querySelectorAll('.accordion-header').forEach((button) => {
		button.addEventListener('click', () => {
			const expanded = button.getAttribute('aria-expanded') === 'true';
			button.setAttribute('aria-expanded', !expanded);

			const content = button.nextElementSibling;

			if (!expanded) {
				content.style.maxHeight = content.scrollHeight + 'px';
			} else {
				content.style.maxHeight = null;
			}

			// Optional: close others
			document.querySelectorAll('.accordion-header').forEach((other) => {
				if (other !== button) {
					other.setAttribute('aria-expanded', false);
					other.nextElementSibling.style.maxHeight = null;
				}
			});
		});
	});
}

export default accordion;
